import React from "react"
import { CommonProviders } from "./providers"

const Providers = ({ initial, children }) => {
  return <CommonProviders initial={initial}>{children}</CommonProviders>
}

export default Providers
